/* This file was auto-generated with the command "generate-graphql-types" */
import * as Types from '~/graphql/generated/types';

import * as Operations from './queries';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAuthenticatedUserQueryVariables = Types.Exact<{
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type GetAuthenticatedUserQuery = {
    authenticatedUser?: {
        id: Types.UUID;
        email: string;
        firstName?: string | null;
        lastName?: string | null;
        isActivated: boolean;
        hasValidActivationToken: boolean;
        mobile?: string | null;
        occupationType?: Types.OccupationType | null;
        roles: Array<Types.Role>;
        accountType?: Types.AccountType | null;
        lastLogin?: string | null;
        gender?: Types.Gender | null;
        createdAt?: string | null;
        country?: string | null;
        dataSharingConsent: boolean;
        medicalIdentificationNumber?: string | null;
        healthProfessionalConfirmation?: boolean | null;
        privacyPolicyConfirmation: boolean;
        isCompleteOnboardingRequired?: boolean | null;
        academicEmail?: {
            id?: Types.UUID | null;
            email?: string | null;
            activated?: boolean | null;
            fileId?: Types.UUID | null;
            activatedAt?: string | null;
            requestedAt?: string | null;
        } | null;
        totalPointCertified: Array<{
            amount?: number | null;
            unit: string;
            mainAccreditation?: boolean | null;
        }>;
        company?: {
            logoUrl?: string | null;
            name?: string | null;
            id: Types.UUID;
            companyPage?: { id: Types.UUID; slug?: string | null } | null;
        } | null;
        academicDegree?: {
            code: string;
            gender?: Types.Gender | null;
            id: string;
            description: Array<{ locale: string; value: string; isSuffix: boolean }>;
        } | null;
    } | null;
};

export type GetSpecialitiesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetSpecialitiesQuery = {
    specialities: Array<{
        id: string;
        code: string;
        description: { translations?: Array<{ locale: string; value: string }> | null };
    }>;
};

export type GetUserForDashboardQueryVariables = Types.Exact<{
    userId: Types.Scalars['ID']['input'];
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type GetUserForDashboardQuery = {
    user?: {
        __typename: 'UserR';
        id: Types.UUID;
        accountType?: Types.AccountType | null;
        ubAccountCode?: string | null;
        email: string;
        firstName?: string | null;
        gender?: Types.Gender | null;
        lastName?: string | null;
        country?: string | null;
        healthProfessionalConfirmation?: boolean | null;
        mobile?: string | null;
        medicalIdentificationNumber?: string | null;
        newsletterSubscription?: boolean | null;
        fieldOfActivity?: Types.FieldOfActivity | null;
        occupationType?: Types.OccupationType | null;
        lastLogin?: string | null;
        roles: Array<Types.Role>;
        isActivated: boolean;
        hasValidActivationToken: boolean;
        createdAt?: string | null;
        dataSharingConsent: boolean;
        privacyPolicyConfirmation: boolean;
        isCompleteOnboardingRequired?: boolean | null;
        academicDegree?: {
            code: string;
            gender?: Types.Gender | null;
            id: string;
            description: Array<{ locale: string; value: string; isSuffix: boolean }>;
        } | null;
        totalPointCertified: Array<{
            amount?: number | null;
            unit: string;
            mainAccreditation?: boolean | null;
        }>;
        totalMembershipPointsEffectedCertified: Array<{
            amount?: number | null;
            unit: string;
            mainAccreditation?: boolean | null;
        }>;
        specialities: Array<{
            id: string;
            code: string;
            description: { translations?: Array<{ locale: string; value: string }> | null };
        }>;
        addresses: Array<{
            __typename: 'AddressR';
            apartmentNumber?: string | null;
            city?: string | null;
            country?: string | null;
            id?: Types.UUID | null;
            postalCode?: string | null;
            street?: string | null;
            isPersonal?: boolean | null;
            fullName?: string | null;
            company?: string | null;
            additionalInformation?: string | null;
        }>;
        company?: {
            id: Types.UUID;
            name?: string | null;
            country?: string | null;
            logoUrl?: string | null;
            companyPage?: {
                id: Types.UUID;
                slug?: string | null;
                publishStatus?: Types.PublishStatusType | null;
            } | null;
        } | null;
    } | null;
};

export type GetUserMembershipQueryVariables = Types.Exact<{
    userId: Types.Scalars['ID']['input'];
}>;

export type GetUserMembershipQuery = {
    userMembership?: {
        __typename: 'UserMembership';
        id: Types.UUID;
        userId?: Types.UUID | null;
        state?: Types.UserMembershipState | null;
        cycle: Types.MembershipCycle;
        expiresAt?: string | null;
        renewalStatus?: Types.UserMembershipRenewalStatus | null;
        membershipRenewalType?: Types.MembershipType | null;
        addedToGroupMembershipDateTime?: string | null;
        initialStartedAt?: string | null;
        startedAt?: string | null;
        items: Array<{
            amountUnit: Types.AmountUnit;
            remainingAmount: number;
            usedAmount: number;
            initialAmount: number;
            membershipItem: {
                __typename: 'MembershipItem';
                amount?: number | null;
                amountUnit?: Types.AmountUnit | null;
                country: string;
                featureType?: Types.MembershipItemFeatureType | null;
                id: Types.UUID;
                price?: number | null;
                membershipItemType: Types.MembershipItemType;
                name: Array<{ locale: string; value: string }>;
            };
        }>;
        membership: {
            __typename: 'Membership';
            occupationType?: Types.OccupationType | null;
            country: string;
            currency: Types.Currency;
            cycle: Types.MembershipCycle;
            id: Types.UUID;
            orderPriority: number;
            price: number;
            recommended: boolean;
            membershipType: Types.MembershipType;
            name?: Array<{ value: string; locale: string }> | null;
            subtitle?: Array<{ locale: string; value: string }> | null;
            membershipItems: Array<{
                __typename: 'MembershipItem';
                amount?: number | null;
                amountUnit?: Types.AmountUnit | null;
                country: string;
                featureType?: Types.MembershipItemFeatureType | null;
                id: Types.UUID;
                price?: number | null;
                membershipItemType: Types.MembershipItemType;
                name: Array<{ locale: string; value: string }>;
            }>;
            validMarketingOptions: Array<{
                value: string;
                label: { translations?: Array<{ locale: string; value: string }> | null };
            }>;
            feeItem?: {
                __typename: 'MembershipItem';
                amount?: number | null;
                amountUnit?: Types.AmountUnit | null;
                country: string;
                featureType?: Types.MembershipItemFeatureType | null;
                id: Types.UUID;
                price?: number | null;
                membershipItemType: Types.MembershipItemType;
                name: Array<{ locale: string; value: string }>;
            } | null;
        };
        legalPaymentReminders?: Array<{ id: Types.UUID } | null> | null;
        pause?: {
            startsAt?: string | null;
            expiresAt?: string | null;
            pauseType?: Types.MembershipPauseType | null;
            pauseState?: Types.MembershipPauseState | null;
        } | null;
    } | null;
};

export type BookingsCountQueryVariables = Types.Exact<{
    searchQuery: Types.BookingSearchQuery;
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type BookingsCountQuery = { bookings: { totalCount?: number | null } };

export type BookingsQueryVariables = Types.Exact<{
    searchQuery: Types.BookingSearchQuery;
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type BookingsQuery = {
    bookings: {
        pageNumber?: number | null;
        pageSize?: number | null;
        totalCount?: number | null;
        data?: Array<{
            bookingDate?: string | null;
            bookingStatus?: Types.BookingStatus | null;
            currency?: Types.Currency | null;
            membershipCreditEffective?: boolean | null;
            totalPrice?: number | null;
            id: Types.UUID;
            userId: Types.UUID;
            ubOrderId?: string | null;
            invoiceLastUpdated?: string | null;
            bookingUpdatedDate?: string | null;
            event?: {
                category: Types.Category;
                description?: string | null;
                endDateTime: string;
                id: Types.UUID;
                ubEventId?: string | null;
                locale?: Locale | null;
                publishedDomains: Array<string>;
                livestream: boolean;
                name: string;
                onSite: boolean;
                eventFormat?: Types.EventFormat | null;
                startDateTime: string;
                availableForMembers: boolean;
                linkedOnDemandCourseId?: Types.UUID | null;
                productCategory?: {
                    code: string;
                    id: Types.UUID;
                    description: Array<{ locale: string; value: string }>;
                } | null;
                city?: {
                    value: string;
                    label: { translations?: Array<{ locale: string; value: string }> | null };
                } | null;
                country?: {
                    value: string;
                    label: { translations?: Array<{ locale: string; value: string }> | null };
                } | null;
                specialities: Array<{
                    value: string;
                    label: { translations?: Array<{ locale: string; value: string }> | null };
                }>;
                items?: Array<{
                    functionId: string;
                    name: string;
                    startDateTime: string;
                    endDateTime: string;
                    ticketType: Types.TicketType;
                } | null> | null;
            } | null;
            participantType?: {
                code: string;
                id: Types.UUID;
                memberIdRequired: boolean;
                occupationType: Types.OccupationType;
                name: Array<{ locale: string; value: string }>;
                country: {
                    value: string;
                    label: { translations?: Array<{ locale: string; value: string }> | null };
                };
            } | null;
            bookingItems: Array<{
                eventBookableItemFunctionId?: string | null;
                bookingItemType?: Types.BookingItemType | null;
                bookingItemStatus?: Types.BookingItemStatus | null;
            }>;
            invoiceFile?: { name?: string | null; downloadUrl?: string | null } | null;
            certificates?: Array<{
                participationType?: Types.ParticipationType | null;
                certificateFile?: { name?: string | null; downloadUrl?: string | null } | null;
            }> | null;
        }> | null;
    };
};

export type GetUserAddressesQueryVariables = Types.Exact<{
    userId: Types.Scalars['ID']['input'];
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type GetUserAddressesQuery = {
    user?: {
        __typename: 'UserR';
        id: Types.UUID;
        addresses: Array<{
            __typename: 'AddressR';
            apartmentNumber?: string | null;
            city?: string | null;
            country?: string | null;
            id?: Types.UUID | null;
            postalCode?: string | null;
            street?: string | null;
            isPersonal?: boolean | null;
            fullName?: string | null;
            company?: string | null;
            additionalInformation?: string | null;
        }>;
    } | null;
};

export type CatalogContentDocumentsQueryVariables = Types.Exact<{
    searchQuery: Types.ContentSearchInput;
}>;

export type CatalogContentDocumentsQuery = {
    contentDocuments: {
        totalCount?: number | null;
        pageNumber?: number | null;
        pageSize?: number | null;
        data: Array<{
            __typename: 'ContentDocument';
            id: Types.UUID;
            bookmarked?: boolean | null;
            brand?: Types.ProductBrand | null;
            endDateTime?: string | null;
            contentId: string;
            contentType: Types.ContentType;
            startDateTime?: string | null;
            scheduleItemsCount?: number | null;
            specialities: Array<string>;
            headerUrl?: string | null;
            dominantColor?: string | null;
            externalId?: string | null;
            willBeBroadcasted?: boolean | null;
            isFree?: boolean | null;
            isAvailableOnHomepage?: boolean | null;
            capacityStatus?: Types.ContentCapacityStatus | null;
            participationOption?: Types.ContentParticipationOption | null;
            locale?: Locale | null;
            city?: Types.JSON | null;
            subtitle?: string | null;
            title?: string | null;
            description?: Types.JSON | null;
            slug?: string | null;
            rating?: number | null;
            validDate?: string | null;
            sponsorships: Array<{
                sponsorCompany?: {
                    name?: string | null;
                    slug?: string | null;
                    id: Types.UUID;
                    logoUrl?: string | null;
                    publishStatus?: Types.PublishStatusType | null;
                } | null;
                sponsorDepartments?: Array<{
                    id: Types.UUID;
                    logoUrl?: string | null;
                } | null> | null;
            }>;
            providers: Array<{
                name?: string | null;
                id: Types.UUID;
                logoUrl?: string | null;
                companyPage?: {
                    id: Types.UUID;
                    slug?: string | null;
                    publishStatus?: Types.PublishStatusType | null;
                } | null;
            }>;
            product?: {
                name?: Types.JSON | null;
                code: string;
                id: Types.UUID;
                country?: string | null;
                specialityIconUrl?: string | null;
                iconPrimaryColor: string;
                brand?: Types.ProductBrand | null;
            } | null;
            credits: Array<{
                amount: number;
                unit: string;
                isApproved?: boolean | null;
                accreditationInstitute?: string | null;
                participationType?: Types.ParticipationType | null;
            }>;
            speakers: Array<{
                id: Types.UUID;
                avatarSrcUrl?: string | null;
                description?: string | null;
                gender?: Types.Gender | null;
                name: string;
                title?: string | null;
            }>;
            topics: Array<{
                id: Types.UUID;
                code: string;
                level?: number | null;
                subtopicPriority?: number | null;
                abbreviation?: Types.JSON | null;
                description?: Types.JSON | null;
                specialityIconUrl?: string | null;
                iconPrimaryColor: string;
                parents: Array<{ code: string }>;
            }>;
            parent?: {
                id: Types.UUID;
                contentType: Types.ContentType;
                isFree?: boolean | null;
                contentId: string;
                title?: string | null;
                city?: Types.JSON | null;
                locale?: Locale | null;
                brand?: Types.ProductBrand | null;
                startDateTime?: string | null;
                providers: Array<{ name?: string | null; id: Types.UUID; logoUrl?: string | null }>;
            } | null;
            source?: {
                thumbnail?: string | null;
                duration?: number | null;
                url?: string | null;
                file?: {
                    downloadUrl?: string | null;
                    name?: string | null;
                    thumbnailUrl?: string | null;
                } | null;
            } | null;
        }>;
        aggregations?: Array<{
            name: string;
            buckets?: Array<{ key?: string | null; value?: string | null } | null> | null;
        } | null> | null;
    };
};

export type ContentDocumentsCountQueryVariables = Types.Exact<{
    searchQuery: Types.ContentSearchInput;
}>;

export type ContentDocumentsCountQuery = { contentDocuments: { totalCount?: number | null } };

export type GetContentByContentIdQueryVariables = Types.Exact<{
    contentId: Types.Scalars['String']['input'];
}>;

export type GetContentByContentIdQuery = {
    content: {
        __typename: 'Content';
        location?: string | null;
        headerUrl?: string | null;
        dominantColor?: string | null;
        publishedCountries: Array<string>;
        eventCost?: number | null;
        specialities: Array<string>;
        subtitle?: string | null;
        id: Types.UUID;
        bookmarked?: boolean | null;
        slug?: string | null;
        brand?: Types.ProductBrand | null;
        endDateTime?: string | null;
        externalId?: string | null;
        contentId: string;
        locale?: Locale | null;
        contentType?: Types.ContentType | null;
        startDateTime?: string | null;
        willBeBroadcasted?: boolean | null;
        willBeOnDemand?: boolean | null;
        isFree?: boolean | null;
        isCommercial?: boolean | null;
        isAvailableOnHomepage?: boolean | null;
        isAvailableOnMediathek?: boolean | null;
        isAvailableWithoutEfn?: boolean | null;
        participationOption?: Types.ContentParticipationOption | null;
        capacityStatus?: Types.ContentCapacityStatus | null;
        description?: Types.JSON | null;
        descriptionTitle?: Types.JSON | null;
        title?: string | null;
        city?: Types.JSON | null;
        order?: number | null;
        isSponsored?: boolean | null;
        rating?: number | null;
        replacementDate?: string | null;
        replacementTitle?: string | null;
        questions?: Array<{ id: Types.UUID } | null> | null;
        bannerButtonSettings?: { text?: Types.JSON | null; url?: string | null } | null;
        certificate?: {
            reportDate?: string | null;
            reportStatus: Types.ReportStatus;
            file?: {
                id: Types.UUID;
                downloadUrl?: string | null;
                url?: string | null;
                name?: string | null;
            } | null;
        } | null;
        schedule: Array<{
            id: Types.UUID;
            bookmarked?: boolean | null;
            slug?: string | null;
            brand?: Types.ProductBrand | null;
            endDateTime?: string | null;
            externalId?: string | null;
            contentId: string;
            locale?: Locale | null;
            contentType?: Types.ContentType | null;
            startDateTime?: string | null;
            willBeBroadcasted?: boolean | null;
            willBeOnDemand?: boolean | null;
            isFree?: boolean | null;
            isCommercial?: boolean | null;
            isAvailableOnHomepage?: boolean | null;
            isAvailableOnMediathek?: boolean | null;
            isAvailableWithoutEfn?: boolean | null;
            participationOption?: Types.ContentParticipationOption | null;
            capacityStatus?: Types.ContentCapacityStatus | null;
            description?: Types.JSON | null;
            descriptionTitle?: Types.JSON | null;
            title?: string | null;
            city?: Types.JSON | null;
            order?: number | null;
            headerUrl?: string | null;
            isSponsored?: boolean | null;
            rating?: number | null;
            replacementDate?: string | null;
            replacementTitle?: string | null;
            bannerButtonSettings?: { text?: Types.JSON | null; url?: string | null } | null;
            contentUnit?: { id: Types.UUID; title: string; order?: number | null } | null;
            provider?: {
                id: Types.UUID;
                name?: string | null;
                country?: string | null;
                logoUrl?: string | null;
                companyPage?: {
                    id: Types.UUID;
                    slug?: string | null;
                    publishStatus?: Types.PublishStatusType | null;
                } | null;
            } | null;
            contentProgress?: {
                completed?: boolean | null;
                contentId: string;
                time?: number | null;
                trackedDateTime?: string | null;
            } | null;
            contentUnits: Array<{ id: Types.UUID; title: string; order?: number | null }>;
            membershipSettings: { availableForMembers: boolean };
            detailsPageSettings?: {
                eventBookable?: boolean | null;
                sponsorDescription?: Types.JSON | null;
                redirectThroughExhibition?: boolean | null;
                showLocation?: boolean | null;
            } | null;
            agendaSettings?: {
                defaultDescription?: Types.JSON | null;
                programTemplate?: Types.AgendaProgramTemplate | null;
                showAgenda?: boolean | null;
                showProgramOverview?: boolean | null;
                showSpeakers?: boolean | null;
            } | null;
            accreditationSettings?: {
                description?: Types.JSON | null;
                showScheme?: boolean | null;
                showSection?: boolean | null;
            } | null;
            seoSettings?: {
                description?: Types.JSON | null;
                image?: string | null;
                indexSetting?: Types.SeoIndexSetting | null;
                title?: Types.JSON | null;
            } | null;
            sponsorships: Array<{
                __typename: 'Sponsorship';
                contentId: Types.UUID;
                description?: Types.JSON | null;
                id: Types.UUID;
                sponsorCompanyId?: Types.UUID | null;
                sponsorshipAmount?: number | null;
                sponsorshipType?: Types.SponsorshipType | null;
                virtualExhibition?: boolean | null;
                symposiumIds: Array<Types.UUID | null>;
                entireEventSponsor?: boolean | null;
                participantRestriction: boolean;
                sponsorCompany?: {
                    id: Types.UUID;
                    name?: string | null;
                    logoUrl?: string | null;
                    websites?: Types.JSON | null;
                    country?: string | null;
                    companyPage?: {
                        id: Types.UUID;
                        slug?: string | null;
                        publishStatus?: Types.PublishStatusType | null;
                    } | null;
                } | null;
                sponsorDepartments?: Array<{
                    logoUrl?: string | null;
                    id: Types.UUID;
                    companyPage?: {
                        id: Types.UUID;
                        publishStatus?: Types.PublishStatusType | null;
                    } | null;
                } | null> | null;
                symposiums: Array<{
                    id: Types.UUID;
                    title?: string | null;
                    startDateTime?: string | null;
                    endDateTime?: string | null;
                    externalId?: string | null;
                    sponsorships: Array<{
                        sponsorshipAmount?: number | null;
                        sponsorCompany?: { logoUrl?: string | null; name?: string | null } | null;
                    }>;
                    speakers: Array<{
                        id: Types.UUID;
                        avatarSrcUrl?: string | null;
                        description?: string | null;
                        gender?: Types.Gender | null;
                        name: string;
                        title?: string | null;
                    }>;
                } | null>;
                content?: {
                    __typename: 'Content';
                    id: Types.UUID;
                    bookmarked?: boolean | null;
                    brand?: Types.ProductBrand | null;
                    startDateTime?: string | null;
                    endDateTime?: string | null;
                    contentId: string;
                    contentType?: Types.ContentType | null;
                    locale?: Locale | null;
                    title?: string | null;
                    city?: Types.JSON | null;
                    headerUrl?: string | null;
                    willBeBroadcasted?: boolean | null;
                    rating?: number | null;
                    externalId?: string | null;
                    product?: {
                        name?: Types.JSON | null;
                        description?: Types.JSON | null;
                        specialityIconUrl?: string | null;
                        code: string;
                        id: Types.UUID;
                        country?: string | null;
                        isScientificLeaderEnabled?: boolean | null;
                        descriptionTitle?: Types.JSON | null;
                        targetGroupIds: Array<Types.UUID>;
                        benefitIds: Array<Types.UUID>;
                        iconPrimaryColor: string;
                    } | null;
                    source?: {
                        thumbnail?: string | null;
                        duration?: number | null;
                        url?: string | null;
                        file?: {
                            downloadUrl?: string | null;
                            name?: string | null;
                            thumbnailUrl?: string | null;
                        } | null;
                    } | null;
                    speakers: Array<{
                        id: Types.UUID;
                        avatarSrcUrl?: string | null;
                        description?: string | null;
                        gender?: Types.Gender | null;
                        name: string;
                        title?: string | null;
                    }>;
                } | null;
            }>;
            partnerships: Array<{
                id: Types.UUID;
                partnershipType?: Types.PartnershipType | null;
                partnerCompany?: { name?: string | null; logoUrl?: string | null } | null;
            }>;
            benefits: Array<{
                id: Types.UUID;
                title?: Types.JSON | null;
                footNote?: Types.JSON | null;
                iconUrl?: string | null;
                isFootNoteEnabled?: boolean | null;
                usage?: Types.BenefitUsage | null;
            }>;
            targetGroups: Array<{ id: Types.UUID; title?: Types.JSON | null }>;
            product?: {
                name?: Types.JSON | null;
                description?: Types.JSON | null;
                specialityIconUrl?: string | null;
                code: string;
                id: Types.UUID;
                country?: string | null;
                isScientificLeaderEnabled?: boolean | null;
                descriptionTitle?: Types.JSON | null;
                targetGroupIds: Array<Types.UUID>;
                benefitIds: Array<Types.UUID>;
                iconPrimaryColor: string;
                benefits: Array<{
                    id: Types.UUID;
                    title?: Types.JSON | null;
                    footNote?: Types.JSON | null;
                    iconUrl?: string | null;
                    isFootNoteEnabled?: boolean | null;
                    usage?: Types.BenefitUsage | null;
                }>;
                targetGroups: Array<{ id: Types.UUID; title?: Types.JSON | null }>;
            } | null;
            credits: Array<{
                amount: number;
                unit: string;
                isApproved?: boolean | null;
                accreditationInstitute?: string | null;
                participationType?: Types.ParticipationType | null;
            }>;
            speakers: Array<{
                id: Types.UUID;
                avatarSrcUrl?: string | null;
                description?: string | null;
                gender?: Types.Gender | null;
                name: string;
                title?: string | null;
            }>;
            topics: Array<{
                id: Types.UUID;
                code: string;
                level?: number | null;
                subtopicPriority?: number | null;
                abbreviation?: Types.JSON | null;
                description?: Types.JSON | null;
                specialityIconUrl?: string | null;
                iconPrimaryColor: string;
                parents: Array<{ code: string }>;
            }>;
            parent?: {
                locale?: Locale | null;
                isFree?: boolean | null;
                sponsorships: Array<{
                    sponsorCompany?: {
                        id: Types.UUID;
                        logoUrl?: string | null;
                        name?: string | null;
                        country?: string | null;
                        companyPage?: {
                            id: Types.UUID;
                            slug?: string | null;
                            publishStatus?: Types.PublishStatusType | null;
                        } | null;
                    } | null;
                    sponsorDepartments?: Array<{
                        logoUrl?: string | null;
                        id: Types.UUID;
                    } | null> | null;
                }>;
            } | null;
            source?: {
                thumbnail?: string | null;
                duration?: number | null;
                url?: string | null;
                file?: {
                    downloadUrl?: string | null;
                    name?: string | null;
                    thumbnailUrl?: string | null;
                } | null;
            } | null;
        }>;
        provider?: {
            id: Types.UUID;
            name?: string | null;
            country?: string | null;
            logoUrl?: string | null;
            companyPage?: {
                id: Types.UUID;
                slug?: string | null;
                publishStatus?: Types.PublishStatusType | null;
            } | null;
        } | null;
        parent?: {
            locale?: Locale | null;
            isFree?: boolean | null;
            id: Types.UUID;
            bookmarked?: boolean | null;
            slug?: string | null;
            brand?: Types.ProductBrand | null;
            endDateTime?: string | null;
            externalId?: string | null;
            contentId: string;
            contentType?: Types.ContentType | null;
            startDateTime?: string | null;
            willBeBroadcasted?: boolean | null;
            willBeOnDemand?: boolean | null;
            isCommercial?: boolean | null;
            isAvailableOnHomepage?: boolean | null;
            isAvailableOnMediathek?: boolean | null;
            isAvailableWithoutEfn?: boolean | null;
            participationOption?: Types.ContentParticipationOption | null;
            capacityStatus?: Types.ContentCapacityStatus | null;
            description?: Types.JSON | null;
            descriptionTitle?: Types.JSON | null;
            title?: string | null;
            city?: Types.JSON | null;
            order?: number | null;
            headerUrl?: string | null;
            isSponsored?: boolean | null;
            rating?: number | null;
            replacementDate?: string | null;
            replacementTitle?: string | null;
            sponsorships: Array<{
                __typename: 'Sponsorship';
                contentId: Types.UUID;
                description?: Types.JSON | null;
                id: Types.UUID;
                sponsorCompanyId?: Types.UUID | null;
                sponsorshipAmount?: number | null;
                sponsorshipType?: Types.SponsorshipType | null;
                virtualExhibition?: boolean | null;
                symposiumIds: Array<Types.UUID | null>;
                entireEventSponsor?: boolean | null;
                participantRestriction: boolean;
                sponsorCompany?: {
                    id: Types.UUID;
                    logoUrl?: string | null;
                    name?: string | null;
                    country?: string | null;
                    websites?: Types.JSON | null;
                    companyPage?: {
                        id: Types.UUID;
                        slug?: string | null;
                        publishStatus?: Types.PublishStatusType | null;
                    } | null;
                } | null;
                sponsorDepartments?: Array<{
                    logoUrl?: string | null;
                    id: Types.UUID;
                    companyPage?: {
                        id: Types.UUID;
                        publishStatus?: Types.PublishStatusType | null;
                    } | null;
                } | null> | null;
                symposiums: Array<{
                    id: Types.UUID;
                    title?: string | null;
                    startDateTime?: string | null;
                    endDateTime?: string | null;
                    externalId?: string | null;
                    sponsorships: Array<{
                        sponsorshipAmount?: number | null;
                        sponsorCompany?: { logoUrl?: string | null; name?: string | null } | null;
                    }>;
                    speakers: Array<{
                        id: Types.UUID;
                        avatarSrcUrl?: string | null;
                        description?: string | null;
                        gender?: Types.Gender | null;
                        name: string;
                        title?: string | null;
                    }>;
                } | null>;
                content?: {
                    __typename: 'Content';
                    id: Types.UUID;
                    bookmarked?: boolean | null;
                    brand?: Types.ProductBrand | null;
                    startDateTime?: string | null;
                    endDateTime?: string | null;
                    contentId: string;
                    contentType?: Types.ContentType | null;
                    locale?: Locale | null;
                    title?: string | null;
                    city?: Types.JSON | null;
                    headerUrl?: string | null;
                    willBeBroadcasted?: boolean | null;
                    rating?: number | null;
                    externalId?: string | null;
                    product?: {
                        name?: Types.JSON | null;
                        description?: Types.JSON | null;
                        specialityIconUrl?: string | null;
                        code: string;
                        id: Types.UUID;
                        country?: string | null;
                        isScientificLeaderEnabled?: boolean | null;
                        descriptionTitle?: Types.JSON | null;
                        targetGroupIds: Array<Types.UUID>;
                        benefitIds: Array<Types.UUID>;
                        iconPrimaryColor: string;
                    } | null;
                    source?: {
                        thumbnail?: string | null;
                        duration?: number | null;
                        url?: string | null;
                        file?: {
                            downloadUrl?: string | null;
                            name?: string | null;
                            thumbnailUrl?: string | null;
                        } | null;
                    } | null;
                    speakers: Array<{
                        id: Types.UUID;
                        avatarSrcUrl?: string | null;
                        description?: string | null;
                        gender?: Types.Gender | null;
                        name: string;
                        title?: string | null;
                    }>;
                } | null;
            }>;
            contentUnit?: { id: Types.UUID; title: string; order?: number | null } | null;
            provider?: {
                id: Types.UUID;
                name?: string | null;
                country?: string | null;
                logoUrl?: string | null;
                companyPage?: {
                    id: Types.UUID;
                    slug?: string | null;
                    publishStatus?: Types.PublishStatusType | null;
                } | null;
            } | null;
            contentProgress?: {
                completed?: boolean | null;
                contentId: string;
                time?: number | null;
                trackedDateTime?: string | null;
            } | null;
            contentUnits: Array<{ id: Types.UUID; title: string; order?: number | null }>;
            membershipSettings: { availableForMembers: boolean };
            detailsPageSettings?: {
                eventBookable?: boolean | null;
                sponsorDescription?: Types.JSON | null;
                redirectThroughExhibition?: boolean | null;
                showLocation?: boolean | null;
            } | null;
            agendaSettings?: {
                defaultDescription?: Types.JSON | null;
                programTemplate?: Types.AgendaProgramTemplate | null;
                showAgenda?: boolean | null;
                showProgramOverview?: boolean | null;
                showSpeakers?: boolean | null;
            } | null;
            accreditationSettings?: {
                description?: Types.JSON | null;
                showScheme?: boolean | null;
                showSection?: boolean | null;
            } | null;
            seoSettings?: {
                description?: Types.JSON | null;
                image?: string | null;
                indexSetting?: Types.SeoIndexSetting | null;
                title?: Types.JSON | null;
            } | null;
            partnerships: Array<{
                id: Types.UUID;
                partnershipType?: Types.PartnershipType | null;
                partnerCompany?: { name?: string | null; logoUrl?: string | null } | null;
            }>;
            benefits: Array<{
                id: Types.UUID;
                title?: Types.JSON | null;
                footNote?: Types.JSON | null;
                iconUrl?: string | null;
                isFootNoteEnabled?: boolean | null;
                usage?: Types.BenefitUsage | null;
            }>;
            targetGroups: Array<{ id: Types.UUID; title?: Types.JSON | null }>;
            product?: {
                name?: Types.JSON | null;
                description?: Types.JSON | null;
                specialityIconUrl?: string | null;
                code: string;
                id: Types.UUID;
                country?: string | null;
                isScientificLeaderEnabled?: boolean | null;
                descriptionTitle?: Types.JSON | null;
                targetGroupIds: Array<Types.UUID>;
                benefitIds: Array<Types.UUID>;
                iconPrimaryColor: string;
                benefits: Array<{
                    id: Types.UUID;
                    title?: Types.JSON | null;
                    footNote?: Types.JSON | null;
                    iconUrl?: string | null;
                    isFootNoteEnabled?: boolean | null;
                    usage?: Types.BenefitUsage | null;
                }>;
                targetGroups: Array<{ id: Types.UUID; title?: Types.JSON | null }>;
            } | null;
            credits: Array<{
                amount: number;
                unit: string;
                isApproved?: boolean | null;
                accreditationInstitute?: string | null;
                participationType?: Types.ParticipationType | null;
            }>;
            speakers: Array<{
                id: Types.UUID;
                avatarSrcUrl?: string | null;
                description?: string | null;
                gender?: Types.Gender | null;
                name: string;
                title?: string | null;
            }>;
            topics: Array<{
                id: Types.UUID;
                code: string;
                level?: number | null;
                subtopicPriority?: number | null;
                abbreviation?: Types.JSON | null;
                description?: Types.JSON | null;
                specialityIconUrl?: string | null;
                iconPrimaryColor: string;
                parents: Array<{ code: string }>;
            }>;
            parent?: {
                locale?: Locale | null;
                isFree?: boolean | null;
                sponsorships: Array<{
                    sponsorCompany?: {
                        id: Types.UUID;
                        logoUrl?: string | null;
                        name?: string | null;
                        country?: string | null;
                        companyPage?: {
                            id: Types.UUID;
                            slug?: string | null;
                            publishStatus?: Types.PublishStatusType | null;
                        } | null;
                    } | null;
                    sponsorDepartments?: Array<{
                        logoUrl?: string | null;
                        id: Types.UUID;
                    } | null> | null;
                }>;
            } | null;
            source?: {
                thumbnail?: string | null;
                duration?: number | null;
                url?: string | null;
                file?: {
                    downloadUrl?: string | null;
                    name?: string | null;
                    thumbnailUrl?: string | null;
                } | null;
            } | null;
        } | null;
        speakers: Array<{
            id: Types.UUID;
            avatarSrcUrl?: string | null;
            description?: string | null;
            gender?: Types.Gender | null;
            name: string;
            title?: string | null;
        }>;
        scientificLeaders: Array<{
            id: Types.UUID;
            avatarSrcUrl?: string | null;
            description?: string | null;
            gender?: Types.Gender | null;
            name: string;
            title?: string | null;
        }>;
        scientificCoLeaders: Array<{
            id: Types.UUID;
            avatarSrcUrl?: string | null;
            description?: string | null;
            gender?: Types.Gender | null;
            name: string;
            title?: string | null;
        }>;
        programSchedules: Array<{
            symposiumPublishedDomains?: Array<string> | null;
            externalId?: string | null;
            id: Types.UUID;
            title?: string | null;
            startDateTime?: string | null;
            endDateTime?: string | null;
            level?: number | null;
            scheduleType?: Types.ProgramScheduleType | null;
            speakers: Array<{
                id: Types.UUID;
                avatarSrcUrl?: string | null;
                description?: string | null;
                gender?: Types.Gender | null;
                name: string;
                title?: string | null;
            }>;
            sponsorships: Array<{
                sponsorshipAmount?: number | null;
                sponsorCompany?: {
                    id: Types.UUID;
                    name?: string | null;
                    country?: string | null;
                    logoUrl?: string | null;
                    companyPage?: {
                        id: Types.UUID;
                        slug?: string | null;
                        publishStatus?: Types.PublishStatusType | null;
                    } | null;
                } | null;
            }>;
        }>;
        attachments: Array<{
            attachmentType?: Types.AttachmentType | null;
            contentId: Types.UUID;
            fileId?: Types.UUID | null;
            groupId?: string | null;
            id: Types.UUID;
            file?: {
                downloadUrl?: string | null;
                id: Types.UUID;
                mimetype?: string | null;
                name?: string | null;
                shortUrl?: string | null;
                size?: number | null;
                uploadUrl?: string | null;
                url?: string | null;
                permissions: Array<{
                    id?: Types.UUID | null;
                    permissionType?: Types.PermissionType | null;
                    scope?: Types.JSON | null;
                } | null>;
            } | null;
        }>;
        sponsorships: Array<{
            __typename: 'Sponsorship';
            contentId: Types.UUID;
            description?: Types.JSON | null;
            id: Types.UUID;
            sponsorCompanyId?: Types.UUID | null;
            sponsorshipAmount?: number | null;
            sponsorshipType?: Types.SponsorshipType | null;
            virtualExhibition?: boolean | null;
            symposiumIds: Array<Types.UUID | null>;
            entireEventSponsor?: boolean | null;
            participantRestriction: boolean;
            sponsorDepartments?: Array<{
                logoUrl?: string | null;
                id: Types.UUID;
                translatedName?: Types.JSON | null;
                companyPage?: {
                    id: Types.UUID;
                    publishStatus?: Types.PublishStatusType | null;
                } | null;
            } | null> | null;
            sponsorCompany?: {
                id: Types.UUID;
                logoUrl?: string | null;
                name?: string | null;
                country?: string | null;
                websites?: Types.JSON | null;
                companyPage?: {
                    id: Types.UUID;
                    slug?: string | null;
                    publishStatus?: Types.PublishStatusType | null;
                } | null;
            } | null;
            symposiums: Array<{
                id: Types.UUID;
                title?: string | null;
                startDateTime?: string | null;
                endDateTime?: string | null;
                externalId?: string | null;
                sponsorships: Array<{
                    sponsorshipAmount?: number | null;
                    sponsorCompany?: { logoUrl?: string | null; name?: string | null } | null;
                }>;
                speakers: Array<{
                    id: Types.UUID;
                    avatarSrcUrl?: string | null;
                    description?: string | null;
                    gender?: Types.Gender | null;
                    name: string;
                    title?: string | null;
                }>;
            } | null>;
            content?: {
                __typename: 'Content';
                id: Types.UUID;
                bookmarked?: boolean | null;
                brand?: Types.ProductBrand | null;
                startDateTime?: string | null;
                endDateTime?: string | null;
                contentId: string;
                contentType?: Types.ContentType | null;
                locale?: Locale | null;
                title?: string | null;
                city?: Types.JSON | null;
                headerUrl?: string | null;
                willBeBroadcasted?: boolean | null;
                rating?: number | null;
                externalId?: string | null;
                product?: {
                    name?: Types.JSON | null;
                    description?: Types.JSON | null;
                    specialityIconUrl?: string | null;
                    code: string;
                    id: Types.UUID;
                    country?: string | null;
                    isScientificLeaderEnabled?: boolean | null;
                    descriptionTitle?: Types.JSON | null;
                    targetGroupIds: Array<Types.UUID>;
                    benefitIds: Array<Types.UUID>;
                    iconPrimaryColor: string;
                } | null;
                source?: {
                    thumbnail?: string | null;
                    duration?: number | null;
                    url?: string | null;
                    file?: {
                        downloadUrl?: string | null;
                        name?: string | null;
                        thumbnailUrl?: string | null;
                    } | null;
                } | null;
                speakers: Array<{
                    id: Types.UUID;
                    avatarSrcUrl?: string | null;
                    description?: string | null;
                    gender?: Types.Gender | null;
                    name: string;
                    title?: string | null;
                }>;
            } | null;
        }>;
        contentUnit?: { id: Types.UUID; title: string; order?: number | null } | null;
        contentProgress?: {
            completed?: boolean | null;
            contentId: string;
            time?: number | null;
            trackedDateTime?: string | null;
        } | null;
        contentUnits: Array<{ id: Types.UUID; title: string; order?: number | null }>;
        membershipSettings: { availableForMembers: boolean };
        detailsPageSettings?: {
            eventBookable?: boolean | null;
            sponsorDescription?: Types.JSON | null;
            redirectThroughExhibition?: boolean | null;
            showLocation?: boolean | null;
        } | null;
        agendaSettings?: {
            defaultDescription?: Types.JSON | null;
            programTemplate?: Types.AgendaProgramTemplate | null;
            showAgenda?: boolean | null;
            showProgramOverview?: boolean | null;
            showSpeakers?: boolean | null;
        } | null;
        accreditationSettings?: {
            description?: Types.JSON | null;
            showScheme?: boolean | null;
            showSection?: boolean | null;
        } | null;
        seoSettings?: {
            description?: Types.JSON | null;
            image?: string | null;
            indexSetting?: Types.SeoIndexSetting | null;
            title?: Types.JSON | null;
        } | null;
        partnerships: Array<{
            id: Types.UUID;
            partnershipType?: Types.PartnershipType | null;
            partnerCompany?: { name?: string | null; logoUrl?: string | null } | null;
        }>;
        benefits: Array<{
            id: Types.UUID;
            title?: Types.JSON | null;
            footNote?: Types.JSON | null;
            iconUrl?: string | null;
            isFootNoteEnabled?: boolean | null;
            usage?: Types.BenefitUsage | null;
        }>;
        targetGroups: Array<{ id: Types.UUID; title?: Types.JSON | null }>;
        product?: {
            name?: Types.JSON | null;
            description?: Types.JSON | null;
            specialityIconUrl?: string | null;
            code: string;
            id: Types.UUID;
            country?: string | null;
            isScientificLeaderEnabled?: boolean | null;
            descriptionTitle?: Types.JSON | null;
            targetGroupIds: Array<Types.UUID>;
            benefitIds: Array<Types.UUID>;
            iconPrimaryColor: string;
            benefits: Array<{
                id: Types.UUID;
                title?: Types.JSON | null;
                footNote?: Types.JSON | null;
                iconUrl?: string | null;
                isFootNoteEnabled?: boolean | null;
                usage?: Types.BenefitUsage | null;
            }>;
            targetGroups: Array<{ id: Types.UUID; title?: Types.JSON | null }>;
        } | null;
        credits: Array<{
            amount: number;
            unit: string;
            isApproved?: boolean | null;
            accreditationInstitute?: string | null;
            participationType?: Types.ParticipationType | null;
        }>;
        topics: Array<{
            id: Types.UUID;
            code: string;
            level?: number | null;
            subtopicPriority?: number | null;
            abbreviation?: Types.JSON | null;
            description?: Types.JSON | null;
            specialityIconUrl?: string | null;
            iconPrimaryColor: string;
            parents: Array<{ code: string }>;
        }>;
        source?: {
            thumbnail?: string | null;
            duration?: number | null;
            url?: string | null;
            file?: {
                downloadUrl?: string | null;
                name?: string | null;
                thumbnailUrl?: string | null;
            } | null;
        } | null;
    };
};

export type GetTenantContentsQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type GetTenantContentsQuery = {
    contentsV2: {
        data: Array<{
            id: Types.UUID;
            title?: string | null;
            brand?: Types.ProductBrand | null;
            provider?: { id: Types.UUID } | null;
        }>;
    };
};

export type GetContentForAnalyticsByIdQueryVariables = Types.Exact<{
    contentId: Types.Scalars['String']['input'];
}>;

export type GetContentForAnalyticsByIdQuery = {
    content: {
        __typename: 'Content';
        id: Types.UUID;
        contentId: string;
        externalId?: string | null;
        brand?: Types.ProductBrand | null;
        city?: Types.JSON | null;
        contentType?: Types.ContentType | null;
        specialities: Array<string>;
        title?: string | null;
        startDateTime?: string | null;
        product?: { code: string; name?: Types.JSON | null } | null;
        partnerships: Array<{
            partnerCompany?: { ubAccountCode?: string | null; name?: string | null } | null;
        }>;
        parent?: {
            id: Types.UUID;
            contentId: string;
            externalId?: string | null;
            contentType?: Types.ContentType | null;
            brand?: Types.ProductBrand | null;
            city?: Types.JSON | null;
            specialities: Array<string>;
            title?: string | null;
            startDateTime?: string | null;
            product?: { code: string; name?: Types.JSON | null } | null;
            partnerships: Array<{
                partnerCompany?: { ubAccountCode?: string | null; name?: string | null } | null;
            }>;
        } | null;
    };
};

export type GetCourseForAnalyticsByIdQueryVariables = Types.Exact<{
    courseId: Types.Scalars['String']['input'];
}>;

export type GetCourseForAnalyticsByIdQuery = {
    course: {
        __typename: 'Course';
        id: Types.UUID;
        contentId: string;
        brand?: Types.ProductBrand | null;
        city?: Types.JSON | null;
        contentType: Types.ContentType;
        specialities: Array<string>;
        title?: string | null;
        startDateTime?: string | null;
        product?: { code: string; name?: Types.JSON | null } | null;
        parent?: {
            id: Types.UUID;
            contentId: string;
            contentType: Types.ContentType;
            brand?: Types.ProductBrand | null;
            city?: Types.JSON | null;
            specialities: Array<string>;
            title?: string | null;
            startDateTime?: string | null;
            product?: { code: string; name?: Types.JSON | null } | null;
        } | null;
    };
};

export type GetAcademicDegreesQueryVariables = Types.Exact<{
    locale: Types.Scalars['String']['input'];
}>;

export type GetAcademicDegreesQuery = {
    userAcademicDegrees: Array<{
        code: string;
        gender?: Types.Gender | null;
        id: string;
        description: Array<{ locale: string; value: string; isSuffix: boolean }>;
    }>;
};

export type GetMembershipsQueryVariables = Types.Exact<{
    country: Types.Scalars['String']['input'];
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type GetMembershipsQuery = {
    memberships?: Array<{
        __typename: 'Membership';
        occupationType?: Types.OccupationType | null;
        country: string;
        currency: Types.Currency;
        cycle: Types.MembershipCycle;
        id: Types.UUID;
        orderPriority: number;
        price: number;
        recommended: boolean;
        membershipType: Types.MembershipType;
        name?: Array<{ value: string; locale: string }> | null;
        subtitle?: Array<{ locale: string; value: string }> | null;
        membershipItems: Array<{
            __typename: 'MembershipItem';
            amount?: number | null;
            amountUnit?: Types.AmountUnit | null;
            country: string;
            featureType?: Types.MembershipItemFeatureType | null;
            id: Types.UUID;
            price?: number | null;
            membershipItemType: Types.MembershipItemType;
            name: Array<{ locale: string; value: string }>;
        }>;
        validMarketingOptions: Array<{
            value: string;
            label: { translations?: Array<{ locale: string; value: string }> | null };
        }>;
        feeItem?: {
            __typename: 'MembershipItem';
            amount?: number | null;
            amountUnit?: Types.AmountUnit | null;
            country: string;
            featureType?: Types.MembershipItemFeatureType | null;
            id: Types.UUID;
            price?: number | null;
            membershipItemType: Types.MembershipItemType;
            name: Array<{ locale: string; value: string }>;
        } | null;
    } | null> | null;
};

export type UserPaymentMethodsQueryVariables = Types.Exact<{
    userId: Types.Scalars['ID']['input'];
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
    requestFromCountry?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type UserPaymentMethodsQuery = {
    userPaymentMethods: Array<{
        brand?: string | null;
        default?: boolean | null;
        last4?: string | null;
        reference?: string | null;
        country?: string | null;
        type?: Types.UserPaymentMethodType | null;
    }>;
};

export type GetEventIdByContentIdQueryVariables = Types.Exact<{
    contentId: Types.Scalars['ID']['input'];
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type GetEventIdByContentIdQuery = {
    eventForBooking?: { id: Types.UUID; content?: { externalId: string } | null } | null;
};

export type GetEventForBookingQueryVariables = Types.Exact<{
    eventId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
    ubEventId?: Types.InputMaybe<Types.Scalars['String']['input']>;
    contentId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
    userId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
    bookingCountry?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GetEventForBookingQuery = {
    eventForBooking?: {
        __typename: 'BookingEventR';
        currency: Types.Currency;
        id: Types.UUID;
        name: string;
        connectedAccountId?: string | null;
        locale?: Locale | null;
        publishedDomains: Array<string>;
        eventFormat: Types.EventFormat;
        startDateTime: string;
        endDateTime: string;
        category: Types.Category;
        taxPercentage?: number | null;
        taxType?: Types.TaxType | null;
        printedCourseBookFunctionId?: string | null;
        printedCourseBookPrice?: number | null;
        availableForMembers: boolean;
        allowedParticipantTypes: Array<{
            code: string;
            id: Types.UUID;
            memberIdRequired: boolean;
            occupationType: Types.OccupationType;
            name: Array<{ locale: string; value: string }>;
            country: {
                value: string;
                label: { translations?: Array<{ locale: string; value: string }> | null };
            };
        }>;
        items: Array<{
            endDateTime: string;
            eventBookableItemId: string;
            name: string;
            participationType: Types.ParticipationType;
            startDateTime: string;
            ticketType: Types.TicketType;
            capacity?: number | null;
            bookedCount?: number | null;
            creditPoints?: Array<{
                amount?: number | null;
                unit: string;
                mainAccreditation?: boolean | null;
            } | null> | null;
            participantTypePrices: Array<{
                currentPrice?: number | null;
                earlyBirdPrice?: number | null;
                latePrice?: number | null;
                normalPrice?: number | null;
                memberPrice?: number | null;
                participantType: {
                    code: string;
                    id: Types.UUID;
                    memberIdRequired: boolean;
                    occupationType: Types.OccupationType;
                    name: Array<{ locale: string; value: string }>;
                    country: {
                        value: string;
                        label: { translations?: Array<{ locale: string; value: string }> | null };
                    };
                };
            }>;
        }>;
        productCategory: {
            code: string;
            id: Types.UUID;
            description: Array<{ locale: string; value: string }>;
        };
        validMarketingOptions: Array<{
            value: string;
            label: { translations?: Array<{ locale: string; value: string }> | null };
        }>;
        city?: {
            value: string;
            label: { translations?: Array<{ locale: string; value: string }> | null };
        } | null;
        country: {
            value: string;
            label: { translations?: Array<{ locale: string; value: string }> | null };
        };
        content?: { contentId?: string | null; externalId: string } | null;
    } | null;
};

export type GetPromoCodeForBookingQueryVariables = Types.Exact<{
    bookingRequest: Types.BookingRequest;
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
    userId: Types.Scalars['ID']['input'];
}>;

export type GetPromoCodeForBookingQuery = {
    promoCodeForBooking?: {
        code: string;
        name: string;
        promoAmount: number;
        promoCodeType: Types.PromoCodeType;
    } | null;
};

export type GetPromoCodeForMembershipQueryVariables = Types.Exact<{
    membershipId: Types.Scalars['ID']['input'];
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
    promoCode: Types.Scalars['String']['input'];
}>;

export type GetPromoCodeForMembershipQuery = {
    promoCodeForMembership?: {
        code: string;
        name: string;
        promoAmount: number;
        promoCodeType: Types.PromoCodeType;
    } | null;
};

export type GetMembershipQueryVariables = Types.Exact<{
    membershipId: Types.Scalars['ID']['input'];
    tenantId?: Types.Scalars['ID']['input'];
}>;

export type GetMembershipQuery = {
    membership?: {
        __typename: 'Membership';
        occupationType?: Types.OccupationType | null;
        country: string;
        currency: Types.Currency;
        cycle: Types.MembershipCycle;
        id: Types.UUID;
        orderPriority: number;
        price: number;
        recommended: boolean;
        membershipType: Types.MembershipType;
        name?: Array<{ value: string; locale: string }> | null;
        subtitle?: Array<{ locale: string; value: string }> | null;
        membershipItems: Array<{
            __typename: 'MembershipItem';
            amount?: number | null;
            amountUnit?: Types.AmountUnit | null;
            country: string;
            featureType?: Types.MembershipItemFeatureType | null;
            id: Types.UUID;
            price?: number | null;
            membershipItemType: Types.MembershipItemType;
            name: Array<{ locale: string; value: string }>;
        }>;
        validMarketingOptions: Array<{
            value: string;
            label: { translations?: Array<{ locale: string; value: string }> | null };
        }>;
        feeItem?: {
            __typename: 'MembershipItem';
            amount?: number | null;
            amountUnit?: Types.AmountUnit | null;
            country: string;
            featureType?: Types.MembershipItemFeatureType | null;
            id: Types.UUID;
            price?: number | null;
            membershipItemType: Types.MembershipItemType;
            name: Array<{ locale: string; value: string }>;
        } | null;
    } | null;
};

export type GetAddOnCoursesForNavbarQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type GetAddOnCoursesForNavbarQuery = {
    courses: {
        totalCount?: number | null;
        pageNumber?: number | null;
        pageSize?: number | null;
        data: Array<{
            __typename: 'Course';
            id: Types.UUID;
            contentId: string;
            title?: string | null;
            subtitle?: string | null;
            brand?: Types.ProductBrand | null;
            courseProgress?: {
                lastWatchedVideo?: {
                    __typename: 'Video';
                    id: Types.UUID;
                    contentId: string;
                    contentType: Types.ContentType;
                    endDateTime?: string | null;
                    replacementDate?: string | null;
                    source?: { duration?: number | null; thumbnail?: string | null } | null;
                    contentProgress?: { completed?: boolean | null; time?: number | null } | null;
                    product?: {
                        __typename: 'Product';
                        id: Types.UUID;
                        specialityIconUrl?: string | null;
                    } | null;
                } | null;
            } | null;
        }>;
    };
};

export type GetAddOnCoursesQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type GetAddOnCoursesQuery = {
    courses: {
        totalCount?: number | null;
        pageNumber?: number | null;
        pageSize?: number | null;
        data: Array<{
            __typename: 'Course';
            id: Types.UUID;
            brand?: Types.ProductBrand | null;
            title?: string | null;
            externalId?: string | null;
            contentId: string;
            subtitle?: string | null;
            certificate?: {
                reportDate?: string | null;
                reportStatus: Types.ReportStatus;
                file?: {
                    id: Types.UUID;
                    downloadUrl?: string | null;
                    url?: string | null;
                    name?: string | null;
                } | null;
            } | null;
            modules: Array<{ id: Types.UUID; title?: string | null; order?: number | null }>;
            topics: Array<{ id: Types.UUID; code: string; description?: Types.JSON | null }>;
            courseProgress?: {
                completedPercent: number;
                lastWatchedVideo?: {
                    contentId: string;
                    endDateTime?: string | null;
                    replacementDate?: string | null;
                    contentType: Types.ContentType;
                    title?: string | null;
                    questions: Array<{ id: Types.UUID }>;
                    source?: { duration?: number | null; thumbnail?: string | null } | null;
                    contentProgress?: { time?: number | null; completed?: boolean | null } | null;
                    product?: { specialityIconUrl?: string | null } | null;
                    contentUnit?: { title: string } | null;
                } | null;
            } | null;
        }>;
    };
};

export type GetContentFileQueryVariables = Types.Exact<{
    contentId: Types.Scalars['String']['input'];
}>;

export type GetContentFileQuery = {
    content: {
        title?: string | null;
        source?: { file?: { downloadUrl?: string | null } | null } | null;
    };
};

export type GetContentByContentIdForBreadcrumbsQueryVariables = Types.Exact<{
    contentId: Types.Scalars['String']['input'];
}>;

export type GetContentByContentIdForBreadcrumbsQuery = {
    content: {
        id: Types.UUID;
        contentId: string;
        title?: string | null;
        contentType?: Types.ContentType | null;
        slug?: string | null;
        brand?: Types.ProductBrand | null;
        city?: Types.JSON | null;
        schedule: Array<{ contentId: string; id: Types.UUID }>;
        parent?: { contentId: string } | null;
    };
};

export type GetCourseByIdForBreadcrumbsQueryVariables = Types.Exact<{
    identifier: Types.Scalars['String']['input'];
}>;

export type GetCourseByIdForBreadcrumbsQuery = {
    course: {
        id: Types.UUID;
        contentId: string;
        title?: string | null;
        contentType: Types.ContentType;
        slug?: string | null;
        brand?: Types.ProductBrand | null;
        startDateTime?: string | null;
        city?: Types.JSON | null;
        videos: Array<{ contentId: string; id: Types.UUID }>;
        parent?: { contentId: string } | null;
    };
};

export type GetContentProgramQueryVariables = Types.Exact<{
    contentId: Types.Scalars['ID']['input'];
}>;

export type GetContentProgramQuery = {
    contentProgram: { file?: { downloadUrl?: string | null } | null };
};

/**
 * __useGetAuthenticatedUserQuery__
 *
 * To run a query within a React component, call `useGetAuthenticatedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthenticatedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthenticatedUserQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetAuthenticatedUserQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetAuthenticatedUserQuery,
        GetAuthenticatedUserQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetAuthenticatedUserQuery, GetAuthenticatedUserQueryVariables>(
        Operations.GetAuthenticatedUser,
        options
    );
}
export function useGetAuthenticatedUserLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAuthenticatedUserQuery,
        GetAuthenticatedUserQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetAuthenticatedUserQuery, GetAuthenticatedUserQueryVariables>(
        Operations.GetAuthenticatedUser,
        options
    );
}
export function useGetAuthenticatedUserSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAuthenticatedUserQuery,
              GetAuthenticatedUserQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetAuthenticatedUserQuery, GetAuthenticatedUserQueryVariables>(
        Operations.GetAuthenticatedUser,
        options
    );
}
export type GetAuthenticatedUserQueryHookResult = ReturnType<typeof useGetAuthenticatedUserQuery>;
export type GetAuthenticatedUserLazyQueryHookResult = ReturnType<
    typeof useGetAuthenticatedUserLazyQuery
>;
export type GetAuthenticatedUserSuspenseQueryHookResult = ReturnType<
    typeof useGetAuthenticatedUserSuspenseQuery
>;
export type GetAuthenticatedUserQueryResult = Apollo.QueryResult<
    GetAuthenticatedUserQuery,
    GetAuthenticatedUserQueryVariables
>;

/**
 * __useGetSpecialitiesQuery__
 *
 * To run a query within a React component, call `useGetSpecialitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecialitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecialitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSpecialitiesQuery(
    baseOptions?: Apollo.QueryHookOptions<GetSpecialitiesQuery, GetSpecialitiesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetSpecialitiesQuery, GetSpecialitiesQueryVariables>(
        Operations.GetSpecialities,
        options
    );
}
export function useGetSpecialitiesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetSpecialitiesQuery, GetSpecialitiesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetSpecialitiesQuery, GetSpecialitiesQueryVariables>(
        Operations.GetSpecialities,
        options
    );
}
export function useGetSpecialitiesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<GetSpecialitiesQuery, GetSpecialitiesQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetSpecialitiesQuery, GetSpecialitiesQueryVariables>(
        Operations.GetSpecialities,
        options
    );
}
export type GetSpecialitiesQueryHookResult = ReturnType<typeof useGetSpecialitiesQuery>;
export type GetSpecialitiesLazyQueryHookResult = ReturnType<typeof useGetSpecialitiesLazyQuery>;
export type GetSpecialitiesSuspenseQueryHookResult = ReturnType<
    typeof useGetSpecialitiesSuspenseQuery
>;
export type GetSpecialitiesQueryResult = Apollo.QueryResult<
    GetSpecialitiesQuery,
    GetSpecialitiesQueryVariables
>;

/**
 * __useGetUserForDashboardQuery__
 *
 * To run a query within a React component, call `useGetUserForDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserForDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserForDashboardQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetUserForDashboardQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetUserForDashboardQuery,
        GetUserForDashboardQueryVariables
    > &
        ({ variables: GetUserForDashboardQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetUserForDashboardQuery, GetUserForDashboardQueryVariables>(
        Operations.GetUserForDashboard,
        options
    );
}
export function useGetUserForDashboardLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUserForDashboardQuery,
        GetUserForDashboardQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetUserForDashboardQuery, GetUserForDashboardQueryVariables>(
        Operations.GetUserForDashboard,
        options
    );
}
export function useGetUserForDashboardSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUserForDashboardQuery,
              GetUserForDashboardQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetUserForDashboardQuery, GetUserForDashboardQueryVariables>(
        Operations.GetUserForDashboard,
        options
    );
}
export type GetUserForDashboardQueryHookResult = ReturnType<typeof useGetUserForDashboardQuery>;
export type GetUserForDashboardLazyQueryHookResult = ReturnType<
    typeof useGetUserForDashboardLazyQuery
>;
export type GetUserForDashboardSuspenseQueryHookResult = ReturnType<
    typeof useGetUserForDashboardSuspenseQuery
>;
export type GetUserForDashboardQueryResult = Apollo.QueryResult<
    GetUserForDashboardQuery,
    GetUserForDashboardQueryVariables
>;

/**
 * __useGetUserMembershipQuery__
 *
 * To run a query within a React component, call `useGetUserMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserMembershipQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserMembershipQuery(
    baseOptions: Apollo.QueryHookOptions<GetUserMembershipQuery, GetUserMembershipQueryVariables> &
        ({ variables: GetUserMembershipQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetUserMembershipQuery, GetUserMembershipQueryVariables>(
        Operations.GetUserMembership,
        options
    );
}
export function useGetUserMembershipLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUserMembershipQuery,
        GetUserMembershipQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetUserMembershipQuery, GetUserMembershipQueryVariables>(
        Operations.GetUserMembership,
        options
    );
}
export function useGetUserMembershipSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<GetUserMembershipQuery, GetUserMembershipQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetUserMembershipQuery, GetUserMembershipQueryVariables>(
        Operations.GetUserMembership,
        options
    );
}
export type GetUserMembershipQueryHookResult = ReturnType<typeof useGetUserMembershipQuery>;
export type GetUserMembershipLazyQueryHookResult = ReturnType<typeof useGetUserMembershipLazyQuery>;
export type GetUserMembershipSuspenseQueryHookResult = ReturnType<
    typeof useGetUserMembershipSuspenseQuery
>;
export type GetUserMembershipQueryResult = Apollo.QueryResult<
    GetUserMembershipQuery,
    GetUserMembershipQueryVariables
>;

/**
 * __useBookingsCountQuery__
 *
 * To run a query within a React component, call `useBookingsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingsCountQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useBookingsCountQuery(
    baseOptions: Apollo.QueryHookOptions<BookingsCountQuery, BookingsCountQueryVariables> &
        ({ variables: BookingsCountQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<BookingsCountQuery, BookingsCountQueryVariables>(
        Operations.BookingsCount,
        options
    );
}
export function useBookingsCountLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<BookingsCountQuery, BookingsCountQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<BookingsCountQuery, BookingsCountQueryVariables>(
        Operations.BookingsCount,
        options
    );
}
export function useBookingsCountSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<BookingsCountQuery, BookingsCountQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<BookingsCountQuery, BookingsCountQueryVariables>(
        Operations.BookingsCount,
        options
    );
}
export type BookingsCountQueryHookResult = ReturnType<typeof useBookingsCountQuery>;
export type BookingsCountLazyQueryHookResult = ReturnType<typeof useBookingsCountLazyQuery>;
export type BookingsCountSuspenseQueryHookResult = ReturnType<typeof useBookingsCountSuspenseQuery>;
export type BookingsCountQueryResult = Apollo.QueryResult<
    BookingsCountQuery,
    BookingsCountQueryVariables
>;

/**
 * __useBookingsQuery__
 *
 * To run a query within a React component, call `useBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingsQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useBookingsQuery(
    baseOptions: Apollo.QueryHookOptions<BookingsQuery, BookingsQueryVariables> &
        ({ variables: BookingsQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<BookingsQuery, BookingsQueryVariables>(Operations.Bookings, options);
}
export function useBookingsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<BookingsQuery, BookingsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<BookingsQuery, BookingsQueryVariables>(Operations.Bookings, options);
}
export function useBookingsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<BookingsQuery, BookingsQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<BookingsQuery, BookingsQueryVariables>(
        Operations.Bookings,
        options
    );
}
export type BookingsQueryHookResult = ReturnType<typeof useBookingsQuery>;
export type BookingsLazyQueryHookResult = ReturnType<typeof useBookingsLazyQuery>;
export type BookingsSuspenseQueryHookResult = ReturnType<typeof useBookingsSuspenseQuery>;
export type BookingsQueryResult = Apollo.QueryResult<BookingsQuery, BookingsQueryVariables>;

/**
 * __useGetUserAddressesQuery__
 *
 * To run a query within a React component, call `useGetUserAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAddressesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetUserAddressesQuery(
    baseOptions: Apollo.QueryHookOptions<GetUserAddressesQuery, GetUserAddressesQueryVariables> &
        ({ variables: GetUserAddressesQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetUserAddressesQuery, GetUserAddressesQueryVariables>(
        Operations.GetUserAddresses,
        options
    );
}
export function useGetUserAddressesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetUserAddressesQuery, GetUserAddressesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetUserAddressesQuery, GetUserAddressesQueryVariables>(
        Operations.GetUserAddresses,
        options
    );
}
export function useGetUserAddressesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<GetUserAddressesQuery, GetUserAddressesQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetUserAddressesQuery, GetUserAddressesQueryVariables>(
        Operations.GetUserAddresses,
        options
    );
}
export type GetUserAddressesQueryHookResult = ReturnType<typeof useGetUserAddressesQuery>;
export type GetUserAddressesLazyQueryHookResult = ReturnType<typeof useGetUserAddressesLazyQuery>;
export type GetUserAddressesSuspenseQueryHookResult = ReturnType<
    typeof useGetUserAddressesSuspenseQuery
>;
export type GetUserAddressesQueryResult = Apollo.QueryResult<
    GetUserAddressesQuery,
    GetUserAddressesQueryVariables
>;

/**
 * __useCatalogContentDocumentsQuery__
 *
 * To run a query within a React component, call `useCatalogContentDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogContentDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogContentDocumentsQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useCatalogContentDocumentsQuery(
    baseOptions: Apollo.QueryHookOptions<
        CatalogContentDocumentsQuery,
        CatalogContentDocumentsQueryVariables
    > &
        ({ variables: CatalogContentDocumentsQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<CatalogContentDocumentsQuery, CatalogContentDocumentsQueryVariables>(
        Operations.CatalogContentDocuments,
        options
    );
}
export function useCatalogContentDocumentsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        CatalogContentDocumentsQuery,
        CatalogContentDocumentsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<CatalogContentDocumentsQuery, CatalogContentDocumentsQueryVariables>(
        Operations.CatalogContentDocuments,
        options
    );
}
export function useCatalogContentDocumentsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              CatalogContentDocumentsQuery,
              CatalogContentDocumentsQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        CatalogContentDocumentsQuery,
        CatalogContentDocumentsQueryVariables
    >(Operations.CatalogContentDocuments, options);
}
export type CatalogContentDocumentsQueryHookResult = ReturnType<
    typeof useCatalogContentDocumentsQuery
>;
export type CatalogContentDocumentsLazyQueryHookResult = ReturnType<
    typeof useCatalogContentDocumentsLazyQuery
>;
export type CatalogContentDocumentsSuspenseQueryHookResult = ReturnType<
    typeof useCatalogContentDocumentsSuspenseQuery
>;
export type CatalogContentDocumentsQueryResult = Apollo.QueryResult<
    CatalogContentDocumentsQuery,
    CatalogContentDocumentsQueryVariables
>;

/**
 * __useContentDocumentsCountQuery__
 *
 * To run a query within a React component, call `useContentDocumentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentDocumentsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentDocumentsCountQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useContentDocumentsCountQuery(
    baseOptions: Apollo.QueryHookOptions<
        ContentDocumentsCountQuery,
        ContentDocumentsCountQueryVariables
    > &
        ({ variables: ContentDocumentsCountQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<ContentDocumentsCountQuery, ContentDocumentsCountQueryVariables>(
        Operations.ContentDocumentsCount,
        options
    );
}
export function useContentDocumentsCountLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ContentDocumentsCountQuery,
        ContentDocumentsCountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<ContentDocumentsCountQuery, ContentDocumentsCountQueryVariables>(
        Operations.ContentDocumentsCount,
        options
    );
}
export function useContentDocumentsCountSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              ContentDocumentsCountQuery,
              ContentDocumentsCountQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<ContentDocumentsCountQuery, ContentDocumentsCountQueryVariables>(
        Operations.ContentDocumentsCount,
        options
    );
}
export type ContentDocumentsCountQueryHookResult = ReturnType<typeof useContentDocumentsCountQuery>;
export type ContentDocumentsCountLazyQueryHookResult = ReturnType<
    typeof useContentDocumentsCountLazyQuery
>;
export type ContentDocumentsCountSuspenseQueryHookResult = ReturnType<
    typeof useContentDocumentsCountSuspenseQuery
>;
export type ContentDocumentsCountQueryResult = Apollo.QueryResult<
    ContentDocumentsCountQuery,
    ContentDocumentsCountQueryVariables
>;

/**
 * __useGetContentByContentIdQuery__
 *
 * To run a query within a React component, call `useGetContentByContentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentByContentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentByContentIdQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useGetContentByContentIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetContentByContentIdQuery,
        GetContentByContentIdQueryVariables
    > &
        ({ variables: GetContentByContentIdQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetContentByContentIdQuery, GetContentByContentIdQueryVariables>(
        Operations.GetContentByContentId,
        options
    );
}
export function useGetContentByContentIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetContentByContentIdQuery,
        GetContentByContentIdQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetContentByContentIdQuery, GetContentByContentIdQueryVariables>(
        Operations.GetContentByContentId,
        options
    );
}
export function useGetContentByContentIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetContentByContentIdQuery,
              GetContentByContentIdQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetContentByContentIdQuery, GetContentByContentIdQueryVariables>(
        Operations.GetContentByContentId,
        options
    );
}
export type GetContentByContentIdQueryHookResult = ReturnType<typeof useGetContentByContentIdQuery>;
export type GetContentByContentIdLazyQueryHookResult = ReturnType<
    typeof useGetContentByContentIdLazyQuery
>;
export type GetContentByContentIdSuspenseQueryHookResult = ReturnType<
    typeof useGetContentByContentIdSuspenseQuery
>;
export type GetContentByContentIdQueryResult = Apollo.QueryResult<
    GetContentByContentIdQuery,
    GetContentByContentIdQueryVariables
>;

/**
 * __useGetTenantContentsQuery__
 *
 * To run a query within a React component, call `useGetTenantContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantContentsQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetTenantContentsQuery(
    baseOptions: Apollo.QueryHookOptions<GetTenantContentsQuery, GetTenantContentsQueryVariables> &
        ({ variables: GetTenantContentsQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetTenantContentsQuery, GetTenantContentsQueryVariables>(
        Operations.GetTenantContents,
        options
    );
}
export function useGetTenantContentsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetTenantContentsQuery,
        GetTenantContentsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetTenantContentsQuery, GetTenantContentsQueryVariables>(
        Operations.GetTenantContents,
        options
    );
}
export function useGetTenantContentsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<GetTenantContentsQuery, GetTenantContentsQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetTenantContentsQuery, GetTenantContentsQueryVariables>(
        Operations.GetTenantContents,
        options
    );
}
export type GetTenantContentsQueryHookResult = ReturnType<typeof useGetTenantContentsQuery>;
export type GetTenantContentsLazyQueryHookResult = ReturnType<typeof useGetTenantContentsLazyQuery>;
export type GetTenantContentsSuspenseQueryHookResult = ReturnType<
    typeof useGetTenantContentsSuspenseQuery
>;
export type GetTenantContentsQueryResult = Apollo.QueryResult<
    GetTenantContentsQuery,
    GetTenantContentsQueryVariables
>;

/**
 * __useGetContentForAnalyticsByIdQuery__
 *
 * To run a query within a React component, call `useGetContentForAnalyticsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentForAnalyticsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentForAnalyticsByIdQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useGetContentForAnalyticsByIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetContentForAnalyticsByIdQuery,
        GetContentForAnalyticsByIdQueryVariables
    > &
        (
            | { variables: GetContentForAnalyticsByIdQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetContentForAnalyticsByIdQuery,
        GetContentForAnalyticsByIdQueryVariables
    >(Operations.GetContentForAnalyticsById, options);
}
export function useGetContentForAnalyticsByIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetContentForAnalyticsByIdQuery,
        GetContentForAnalyticsByIdQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetContentForAnalyticsByIdQuery,
        GetContentForAnalyticsByIdQueryVariables
    >(Operations.GetContentForAnalyticsById, options);
}
export function useGetContentForAnalyticsByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetContentForAnalyticsByIdQuery,
              GetContentForAnalyticsByIdQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetContentForAnalyticsByIdQuery,
        GetContentForAnalyticsByIdQueryVariables
    >(Operations.GetContentForAnalyticsById, options);
}
export type GetContentForAnalyticsByIdQueryHookResult = ReturnType<
    typeof useGetContentForAnalyticsByIdQuery
>;
export type GetContentForAnalyticsByIdLazyQueryHookResult = ReturnType<
    typeof useGetContentForAnalyticsByIdLazyQuery
>;
export type GetContentForAnalyticsByIdSuspenseQueryHookResult = ReturnType<
    typeof useGetContentForAnalyticsByIdSuspenseQuery
>;
export type GetContentForAnalyticsByIdQueryResult = Apollo.QueryResult<
    GetContentForAnalyticsByIdQuery,
    GetContentForAnalyticsByIdQueryVariables
>;

/**
 * __useGetCourseForAnalyticsByIdQuery__
 *
 * To run a query within a React component, call `useGetCourseForAnalyticsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseForAnalyticsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseForAnalyticsByIdQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseForAnalyticsByIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetCourseForAnalyticsByIdQuery,
        GetCourseForAnalyticsByIdQueryVariables
    > &
        ({ variables: GetCourseForAnalyticsByIdQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetCourseForAnalyticsByIdQuery, GetCourseForAnalyticsByIdQueryVariables>(
        Operations.GetCourseForAnalyticsById,
        options
    );
}
export function useGetCourseForAnalyticsByIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetCourseForAnalyticsByIdQuery,
        GetCourseForAnalyticsByIdQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetCourseForAnalyticsByIdQuery,
        GetCourseForAnalyticsByIdQueryVariables
    >(Operations.GetCourseForAnalyticsById, options);
}
export function useGetCourseForAnalyticsByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetCourseForAnalyticsByIdQuery,
              GetCourseForAnalyticsByIdQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetCourseForAnalyticsByIdQuery,
        GetCourseForAnalyticsByIdQueryVariables
    >(Operations.GetCourseForAnalyticsById, options);
}
export type GetCourseForAnalyticsByIdQueryHookResult = ReturnType<
    typeof useGetCourseForAnalyticsByIdQuery
>;
export type GetCourseForAnalyticsByIdLazyQueryHookResult = ReturnType<
    typeof useGetCourseForAnalyticsByIdLazyQuery
>;
export type GetCourseForAnalyticsByIdSuspenseQueryHookResult = ReturnType<
    typeof useGetCourseForAnalyticsByIdSuspenseQuery
>;
export type GetCourseForAnalyticsByIdQueryResult = Apollo.QueryResult<
    GetCourseForAnalyticsByIdQuery,
    GetCourseForAnalyticsByIdQueryVariables
>;

/**
 * __useGetAcademicDegreesQuery__
 *
 * To run a query within a React component, call `useGetAcademicDegreesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcademicDegreesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcademicDegreesQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetAcademicDegreesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAcademicDegreesQuery,
        GetAcademicDegreesQueryVariables
    > &
        ({ variables: GetAcademicDegreesQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetAcademicDegreesQuery, GetAcademicDegreesQueryVariables>(
        Operations.GetAcademicDegrees,
        options
    );
}
export function useGetAcademicDegreesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAcademicDegreesQuery,
        GetAcademicDegreesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetAcademicDegreesQuery, GetAcademicDegreesQueryVariables>(
        Operations.GetAcademicDegrees,
        options
    );
}
export function useGetAcademicDegreesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<GetAcademicDegreesQuery, GetAcademicDegreesQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetAcademicDegreesQuery, GetAcademicDegreesQueryVariables>(
        Operations.GetAcademicDegrees,
        options
    );
}
export type GetAcademicDegreesQueryHookResult = ReturnType<typeof useGetAcademicDegreesQuery>;
export type GetAcademicDegreesLazyQueryHookResult = ReturnType<
    typeof useGetAcademicDegreesLazyQuery
>;
export type GetAcademicDegreesSuspenseQueryHookResult = ReturnType<
    typeof useGetAcademicDegreesSuspenseQuery
>;
export type GetAcademicDegreesQueryResult = Apollo.QueryResult<
    GetAcademicDegreesQuery,
    GetAcademicDegreesQueryVariables
>;

/**
 * __useGetMembershipsQuery__
 *
 * To run a query within a React component, call `useGetMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembershipsQuery({
 *   variables: {
 *      country: // value for 'country'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetMembershipsQuery(
    baseOptions: Apollo.QueryHookOptions<GetMembershipsQuery, GetMembershipsQueryVariables> &
        ({ variables: GetMembershipsQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetMembershipsQuery, GetMembershipsQueryVariables>(
        Operations.GetMemberships,
        options
    );
}
export function useGetMembershipsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetMembershipsQuery, GetMembershipsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetMembershipsQuery, GetMembershipsQueryVariables>(
        Operations.GetMemberships,
        options
    );
}
export function useGetMembershipsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<GetMembershipsQuery, GetMembershipsQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetMembershipsQuery, GetMembershipsQueryVariables>(
        Operations.GetMemberships,
        options
    );
}
export type GetMembershipsQueryHookResult = ReturnType<typeof useGetMembershipsQuery>;
export type GetMembershipsLazyQueryHookResult = ReturnType<typeof useGetMembershipsLazyQuery>;
export type GetMembershipsSuspenseQueryHookResult = ReturnType<
    typeof useGetMembershipsSuspenseQuery
>;
export type GetMembershipsQueryResult = Apollo.QueryResult<
    GetMembershipsQuery,
    GetMembershipsQueryVariables
>;

/**
 * __useUserPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useUserPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPaymentMethodsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      tenantId: // value for 'tenantId'
 *      requestFromCountry: // value for 'requestFromCountry'
 *   },
 * });
 */
export function useUserPaymentMethodsQuery(
    baseOptions: Apollo.QueryHookOptions<
        UserPaymentMethodsQuery,
        UserPaymentMethodsQueryVariables
    > &
        ({ variables: UserPaymentMethodsQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<UserPaymentMethodsQuery, UserPaymentMethodsQueryVariables>(
        Operations.UserPaymentMethods,
        options
    );
}
export function useUserPaymentMethodsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        UserPaymentMethodsQuery,
        UserPaymentMethodsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<UserPaymentMethodsQuery, UserPaymentMethodsQueryVariables>(
        Operations.UserPaymentMethods,
        options
    );
}
export function useUserPaymentMethodsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<UserPaymentMethodsQuery, UserPaymentMethodsQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<UserPaymentMethodsQuery, UserPaymentMethodsQueryVariables>(
        Operations.UserPaymentMethods,
        options
    );
}
export type UserPaymentMethodsQueryHookResult = ReturnType<typeof useUserPaymentMethodsQuery>;
export type UserPaymentMethodsLazyQueryHookResult = ReturnType<
    typeof useUserPaymentMethodsLazyQuery
>;
export type UserPaymentMethodsSuspenseQueryHookResult = ReturnType<
    typeof useUserPaymentMethodsSuspenseQuery
>;
export type UserPaymentMethodsQueryResult = Apollo.QueryResult<
    UserPaymentMethodsQuery,
    UserPaymentMethodsQueryVariables
>;

/**
 * __useGetEventIdByContentIdQuery__
 *
 * To run a query within a React component, call `useGetEventIdByContentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventIdByContentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventIdByContentIdQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetEventIdByContentIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetEventIdByContentIdQuery,
        GetEventIdByContentIdQueryVariables
    > &
        ({ variables: GetEventIdByContentIdQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetEventIdByContentIdQuery, GetEventIdByContentIdQueryVariables>(
        Operations.GetEventIdByContentId,
        options
    );
}
export function useGetEventIdByContentIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetEventIdByContentIdQuery,
        GetEventIdByContentIdQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetEventIdByContentIdQuery, GetEventIdByContentIdQueryVariables>(
        Operations.GetEventIdByContentId,
        options
    );
}
export function useGetEventIdByContentIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetEventIdByContentIdQuery,
              GetEventIdByContentIdQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetEventIdByContentIdQuery, GetEventIdByContentIdQueryVariables>(
        Operations.GetEventIdByContentId,
        options
    );
}
export type GetEventIdByContentIdQueryHookResult = ReturnType<typeof useGetEventIdByContentIdQuery>;
export type GetEventIdByContentIdLazyQueryHookResult = ReturnType<
    typeof useGetEventIdByContentIdLazyQuery
>;
export type GetEventIdByContentIdSuspenseQueryHookResult = ReturnType<
    typeof useGetEventIdByContentIdSuspenseQuery
>;
export type GetEventIdByContentIdQueryResult = Apollo.QueryResult<
    GetEventIdByContentIdQuery,
    GetEventIdByContentIdQueryVariables
>;

/**
 * __useGetEventForBookingQuery__
 *
 * To run a query within a React component, call `useGetEventForBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventForBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventForBookingQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      ubEventId: // value for 'ubEventId'
 *      contentId: // value for 'contentId'
 *      tenantId: // value for 'tenantId'
 *      userId: // value for 'userId'
 *      bookingCountry: // value for 'bookingCountry'
 *   },
 * });
 */
export function useGetEventForBookingQuery(
    baseOptions?: Apollo.QueryHookOptions<GetEventForBookingQuery, GetEventForBookingQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetEventForBookingQuery, GetEventForBookingQueryVariables>(
        Operations.GetEventForBooking,
        options
    );
}
export function useGetEventForBookingLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetEventForBookingQuery,
        GetEventForBookingQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetEventForBookingQuery, GetEventForBookingQueryVariables>(
        Operations.GetEventForBooking,
        options
    );
}
export function useGetEventForBookingSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<GetEventForBookingQuery, GetEventForBookingQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetEventForBookingQuery, GetEventForBookingQueryVariables>(
        Operations.GetEventForBooking,
        options
    );
}
export type GetEventForBookingQueryHookResult = ReturnType<typeof useGetEventForBookingQuery>;
export type GetEventForBookingLazyQueryHookResult = ReturnType<
    typeof useGetEventForBookingLazyQuery
>;
export type GetEventForBookingSuspenseQueryHookResult = ReturnType<
    typeof useGetEventForBookingSuspenseQuery
>;
export type GetEventForBookingQueryResult = Apollo.QueryResult<
    GetEventForBookingQuery,
    GetEventForBookingQueryVariables
>;

/**
 * __useGetPromoCodeForBookingQuery__
 *
 * To run a query within a React component, call `useGetPromoCodeForBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromoCodeForBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromoCodeForBookingQuery({
 *   variables: {
 *      bookingRequest: // value for 'bookingRequest'
 *      tenantId: // value for 'tenantId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetPromoCodeForBookingQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetPromoCodeForBookingQuery,
        GetPromoCodeForBookingQueryVariables
    > &
        ({ variables: GetPromoCodeForBookingQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetPromoCodeForBookingQuery, GetPromoCodeForBookingQueryVariables>(
        Operations.GetPromoCodeForBooking,
        options
    );
}
export function useGetPromoCodeForBookingLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetPromoCodeForBookingQuery,
        GetPromoCodeForBookingQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetPromoCodeForBookingQuery, GetPromoCodeForBookingQueryVariables>(
        Operations.GetPromoCodeForBooking,
        options
    );
}
export function useGetPromoCodeForBookingSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPromoCodeForBookingQuery,
              GetPromoCodeForBookingQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetPromoCodeForBookingQuery,
        GetPromoCodeForBookingQueryVariables
    >(Operations.GetPromoCodeForBooking, options);
}
export type GetPromoCodeForBookingQueryHookResult = ReturnType<
    typeof useGetPromoCodeForBookingQuery
>;
export type GetPromoCodeForBookingLazyQueryHookResult = ReturnType<
    typeof useGetPromoCodeForBookingLazyQuery
>;
export type GetPromoCodeForBookingSuspenseQueryHookResult = ReturnType<
    typeof useGetPromoCodeForBookingSuspenseQuery
>;
export type GetPromoCodeForBookingQueryResult = Apollo.QueryResult<
    GetPromoCodeForBookingQuery,
    GetPromoCodeForBookingQueryVariables
>;

/**
 * __useGetPromoCodeForMembershipQuery__
 *
 * To run a query within a React component, call `useGetPromoCodeForMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromoCodeForMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromoCodeForMembershipQuery({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *      tenantId: // value for 'tenantId'
 *      promoCode: // value for 'promoCode'
 *   },
 * });
 */
export function useGetPromoCodeForMembershipQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetPromoCodeForMembershipQuery,
        GetPromoCodeForMembershipQueryVariables
    > &
        ({ variables: GetPromoCodeForMembershipQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetPromoCodeForMembershipQuery, GetPromoCodeForMembershipQueryVariables>(
        Operations.GetPromoCodeForMembership,
        options
    );
}
export function useGetPromoCodeForMembershipLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetPromoCodeForMembershipQuery,
        GetPromoCodeForMembershipQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetPromoCodeForMembershipQuery,
        GetPromoCodeForMembershipQueryVariables
    >(Operations.GetPromoCodeForMembership, options);
}
export function useGetPromoCodeForMembershipSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPromoCodeForMembershipQuery,
              GetPromoCodeForMembershipQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetPromoCodeForMembershipQuery,
        GetPromoCodeForMembershipQueryVariables
    >(Operations.GetPromoCodeForMembership, options);
}
export type GetPromoCodeForMembershipQueryHookResult = ReturnType<
    typeof useGetPromoCodeForMembershipQuery
>;
export type GetPromoCodeForMembershipLazyQueryHookResult = ReturnType<
    typeof useGetPromoCodeForMembershipLazyQuery
>;
export type GetPromoCodeForMembershipSuspenseQueryHookResult = ReturnType<
    typeof useGetPromoCodeForMembershipSuspenseQuery
>;
export type GetPromoCodeForMembershipQueryResult = Apollo.QueryResult<
    GetPromoCodeForMembershipQuery,
    GetPromoCodeForMembershipQueryVariables
>;

/**
 * __useGetMembershipQuery__
 *
 * To run a query within a React component, call `useGetMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembershipQuery({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetMembershipQuery(
    baseOptions: Apollo.QueryHookOptions<GetMembershipQuery, GetMembershipQueryVariables> &
        ({ variables: GetMembershipQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetMembershipQuery, GetMembershipQueryVariables>(
        Operations.GetMembership,
        options
    );
}
export function useGetMembershipLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetMembershipQuery, GetMembershipQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetMembershipQuery, GetMembershipQueryVariables>(
        Operations.GetMembership,
        options
    );
}
export function useGetMembershipSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<GetMembershipQuery, GetMembershipQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetMembershipQuery, GetMembershipQueryVariables>(
        Operations.GetMembership,
        options
    );
}
export type GetMembershipQueryHookResult = ReturnType<typeof useGetMembershipQuery>;
export type GetMembershipLazyQueryHookResult = ReturnType<typeof useGetMembershipLazyQuery>;
export type GetMembershipSuspenseQueryHookResult = ReturnType<typeof useGetMembershipSuspenseQuery>;
export type GetMembershipQueryResult = Apollo.QueryResult<
    GetMembershipQuery,
    GetMembershipQueryVariables
>;

/**
 * __useGetAddOnCoursesForNavbarQuery__
 *
 * To run a query within a React component, call `useGetAddOnCoursesForNavbarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddOnCoursesForNavbarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddOnCoursesForNavbarQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetAddOnCoursesForNavbarQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAddOnCoursesForNavbarQuery,
        GetAddOnCoursesForNavbarQueryVariables
    > &
        ({ variables: GetAddOnCoursesForNavbarQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetAddOnCoursesForNavbarQuery, GetAddOnCoursesForNavbarQueryVariables>(
        Operations.GetAddOnCoursesForNavbar,
        options
    );
}
export function useGetAddOnCoursesForNavbarLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAddOnCoursesForNavbarQuery,
        GetAddOnCoursesForNavbarQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetAddOnCoursesForNavbarQuery,
        GetAddOnCoursesForNavbarQueryVariables
    >(Operations.GetAddOnCoursesForNavbar, options);
}
export function useGetAddOnCoursesForNavbarSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetAddOnCoursesForNavbarQuery,
              GetAddOnCoursesForNavbarQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetAddOnCoursesForNavbarQuery,
        GetAddOnCoursesForNavbarQueryVariables
    >(Operations.GetAddOnCoursesForNavbar, options);
}
export type GetAddOnCoursesForNavbarQueryHookResult = ReturnType<
    typeof useGetAddOnCoursesForNavbarQuery
>;
export type GetAddOnCoursesForNavbarLazyQueryHookResult = ReturnType<
    typeof useGetAddOnCoursesForNavbarLazyQuery
>;
export type GetAddOnCoursesForNavbarSuspenseQueryHookResult = ReturnType<
    typeof useGetAddOnCoursesForNavbarSuspenseQuery
>;
export type GetAddOnCoursesForNavbarQueryResult = Apollo.QueryResult<
    GetAddOnCoursesForNavbarQuery,
    GetAddOnCoursesForNavbarQueryVariables
>;

/**
 * __useGetAddOnCoursesQuery__
 *
 * To run a query within a React component, call `useGetAddOnCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddOnCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddOnCoursesQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetAddOnCoursesQuery(
    baseOptions: Apollo.QueryHookOptions<GetAddOnCoursesQuery, GetAddOnCoursesQueryVariables> &
        ({ variables: GetAddOnCoursesQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetAddOnCoursesQuery, GetAddOnCoursesQueryVariables>(
        Operations.GetAddOnCourses,
        options
    );
}
export function useGetAddOnCoursesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetAddOnCoursesQuery, GetAddOnCoursesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetAddOnCoursesQuery, GetAddOnCoursesQueryVariables>(
        Operations.GetAddOnCourses,
        options
    );
}
export function useGetAddOnCoursesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<GetAddOnCoursesQuery, GetAddOnCoursesQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetAddOnCoursesQuery, GetAddOnCoursesQueryVariables>(
        Operations.GetAddOnCourses,
        options
    );
}
export type GetAddOnCoursesQueryHookResult = ReturnType<typeof useGetAddOnCoursesQuery>;
export type GetAddOnCoursesLazyQueryHookResult = ReturnType<typeof useGetAddOnCoursesLazyQuery>;
export type GetAddOnCoursesSuspenseQueryHookResult = ReturnType<
    typeof useGetAddOnCoursesSuspenseQuery
>;
export type GetAddOnCoursesQueryResult = Apollo.QueryResult<
    GetAddOnCoursesQuery,
    GetAddOnCoursesQueryVariables
>;

/**
 * __useGetContentFileQuery__
 *
 * To run a query within a React component, call `useGetContentFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentFileQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useGetContentFileQuery(
    baseOptions: Apollo.QueryHookOptions<GetContentFileQuery, GetContentFileQueryVariables> &
        ({ variables: GetContentFileQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetContentFileQuery, GetContentFileQueryVariables>(
        Operations.GetContentFile,
        options
    );
}
export function useGetContentFileLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetContentFileQuery, GetContentFileQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetContentFileQuery, GetContentFileQueryVariables>(
        Operations.GetContentFile,
        options
    );
}
export function useGetContentFileSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<GetContentFileQuery, GetContentFileQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetContentFileQuery, GetContentFileQueryVariables>(
        Operations.GetContentFile,
        options
    );
}
export type GetContentFileQueryHookResult = ReturnType<typeof useGetContentFileQuery>;
export type GetContentFileLazyQueryHookResult = ReturnType<typeof useGetContentFileLazyQuery>;
export type GetContentFileSuspenseQueryHookResult = ReturnType<
    typeof useGetContentFileSuspenseQuery
>;
export type GetContentFileQueryResult = Apollo.QueryResult<
    GetContentFileQuery,
    GetContentFileQueryVariables
>;

/**
 * __useGetContentByContentIdForBreadcrumbsQuery__
 *
 * To run a query within a React component, call `useGetContentByContentIdForBreadcrumbsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentByContentIdForBreadcrumbsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentByContentIdForBreadcrumbsQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useGetContentByContentIdForBreadcrumbsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetContentByContentIdForBreadcrumbsQuery,
        GetContentByContentIdForBreadcrumbsQueryVariables
    > &
        (
            | { variables: GetContentByContentIdForBreadcrumbsQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetContentByContentIdForBreadcrumbsQuery,
        GetContentByContentIdForBreadcrumbsQueryVariables
    >(Operations.GetContentByContentIdForBreadcrumbs, options);
}
export function useGetContentByContentIdForBreadcrumbsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetContentByContentIdForBreadcrumbsQuery,
        GetContentByContentIdForBreadcrumbsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetContentByContentIdForBreadcrumbsQuery,
        GetContentByContentIdForBreadcrumbsQueryVariables
    >(Operations.GetContentByContentIdForBreadcrumbs, options);
}
export function useGetContentByContentIdForBreadcrumbsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetContentByContentIdForBreadcrumbsQuery,
              GetContentByContentIdForBreadcrumbsQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetContentByContentIdForBreadcrumbsQuery,
        GetContentByContentIdForBreadcrumbsQueryVariables
    >(Operations.GetContentByContentIdForBreadcrumbs, options);
}
export type GetContentByContentIdForBreadcrumbsQueryHookResult = ReturnType<
    typeof useGetContentByContentIdForBreadcrumbsQuery
>;
export type GetContentByContentIdForBreadcrumbsLazyQueryHookResult = ReturnType<
    typeof useGetContentByContentIdForBreadcrumbsLazyQuery
>;
export type GetContentByContentIdForBreadcrumbsSuspenseQueryHookResult = ReturnType<
    typeof useGetContentByContentIdForBreadcrumbsSuspenseQuery
>;
export type GetContentByContentIdForBreadcrumbsQueryResult = Apollo.QueryResult<
    GetContentByContentIdForBreadcrumbsQuery,
    GetContentByContentIdForBreadcrumbsQueryVariables
>;

/**
 * __useGetCourseByIdForBreadcrumbsQuery__
 *
 * To run a query within a React component, call `useGetCourseByIdForBreadcrumbsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseByIdForBreadcrumbsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseByIdForBreadcrumbsQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useGetCourseByIdForBreadcrumbsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetCourseByIdForBreadcrumbsQuery,
        GetCourseByIdForBreadcrumbsQueryVariables
    > &
        (
            | { variables: GetCourseByIdForBreadcrumbsQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetCourseByIdForBreadcrumbsQuery,
        GetCourseByIdForBreadcrumbsQueryVariables
    >(Operations.GetCourseByIdForBreadcrumbs, options);
}
export function useGetCourseByIdForBreadcrumbsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetCourseByIdForBreadcrumbsQuery,
        GetCourseByIdForBreadcrumbsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetCourseByIdForBreadcrumbsQuery,
        GetCourseByIdForBreadcrumbsQueryVariables
    >(Operations.GetCourseByIdForBreadcrumbs, options);
}
export function useGetCourseByIdForBreadcrumbsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetCourseByIdForBreadcrumbsQuery,
              GetCourseByIdForBreadcrumbsQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetCourseByIdForBreadcrumbsQuery,
        GetCourseByIdForBreadcrumbsQueryVariables
    >(Operations.GetCourseByIdForBreadcrumbs, options);
}
export type GetCourseByIdForBreadcrumbsQueryHookResult = ReturnType<
    typeof useGetCourseByIdForBreadcrumbsQuery
>;
export type GetCourseByIdForBreadcrumbsLazyQueryHookResult = ReturnType<
    typeof useGetCourseByIdForBreadcrumbsLazyQuery
>;
export type GetCourseByIdForBreadcrumbsSuspenseQueryHookResult = ReturnType<
    typeof useGetCourseByIdForBreadcrumbsSuspenseQuery
>;
export type GetCourseByIdForBreadcrumbsQueryResult = Apollo.QueryResult<
    GetCourseByIdForBreadcrumbsQuery,
    GetCourseByIdForBreadcrumbsQueryVariables
>;

/**
 * __useGetContentProgramQuery__
 *
 * To run a query within a React component, call `useGetContentProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentProgramQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useGetContentProgramQuery(
    baseOptions: Apollo.QueryHookOptions<GetContentProgramQuery, GetContentProgramQueryVariables> &
        ({ variables: GetContentProgramQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetContentProgramQuery, GetContentProgramQueryVariables>(
        Operations.GetContentProgram,
        options
    );
}
export function useGetContentProgramLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetContentProgramQuery,
        GetContentProgramQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetContentProgramQuery, GetContentProgramQueryVariables>(
        Operations.GetContentProgram,
        options
    );
}
export function useGetContentProgramSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<GetContentProgramQuery, GetContentProgramQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetContentProgramQuery, GetContentProgramQueryVariables>(
        Operations.GetContentProgram,
        options
    );
}
export type GetContentProgramQueryHookResult = ReturnType<typeof useGetContentProgramQuery>;
export type GetContentProgramLazyQueryHookResult = ReturnType<typeof useGetContentProgramLazyQuery>;
export type GetContentProgramSuspenseQueryHookResult = ReturnType<
    typeof useGetContentProgramSuspenseQuery
>;
export type GetContentProgramQueryResult = Apollo.QueryResult<
    GetContentProgramQuery,
    GetContentProgramQueryVariables
>;
